import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Check } from "lucide-react";
import { applyPageSeo } from "../lib/seo";
import { appFeatures, images } from "../data/content";
import { useEffect } from "react";

const ext = { target: "_blank", rel: "noopener noreferrer" };

const IOS_BADGE = "/ios-app-badge-300x101.png";
const ANDROID_BADGE = "/google-play-badge-1-300x88.png";
const IOS_URL = "https://apps.apple.com/gb/app/freeman-jones/id6472038665";
const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.freemanjones.selfserve.app.android&gl=GB";

export const TryOurAppPage = () => {
  useEffect(() => {
    applyPageSeo({
      title: "Try Our App | Freeman Jones",
      description: "Download the free Freeman Jones IVA customer app for iOS and Android.",
      path: "/try-our-app",
    });
  }, []);

  return (
    <section id="top" data-testid="try-our-app-page" className="bg-brand-bg">
      <div className="mx-auto max-w-3xl px-4 py-14 lg:px-8 lg:py-20">
        <Link
          to="/"
          className="inline-flex min-h-[44px] items-center gap-2 rounded-full text-sm font-semibold text-brand-teal transition-colors hover:text-brand-tealHover"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" /> Back to homepage
        </Link>

        <h1 className="mt-6 font-heading text-4xl font-bold text-brand-navy sm:text-5xl">
          IVA Customer
        </h1>
        <p className="mt-3 text-lg font-semibold text-brand-teal">
          Download our free IVA app today!
        </p>

        <div className="mt-6 flex items-center gap-4">
          <a {...ext} href={IOS_URL} aria-label="Download on the App Store">
            <img src={IOS_BADGE} alt="Download on the App Store" width="120" height="40" />
          </a>
          <a {...ext} href={ANDROID_URL} aria-label="Get it on Google Play">
            <img src={ANDROID_BADGE} alt="Get it on Google Play" width="135" height="40" />
          </a>
        </div>

        <div className="mt-10 space-y-10">
          <section aria-labelledby="app-features">
            <h2
              id="app-features"
              className="font-heading text-base font-bold text-brand-navy md:text-lg"
            >
              What you can do with the app
            </h2>
            <ul className="mt-4 space-y-3">
              {appFeatures.map((f) => (
                <li key={f.title} className="flex gap-3">
                  <span className="mt-0.5 grid h-6 w-6 flex-shrink-0 place-items-center rounded-full bg-brand-teal/10 text-brand-teal">
                    <Check className="h-4 w-4" aria-hidden="true" />
                  </span>
                  <span className="text-base leading-relaxed text-brand-body">
                    <span className="font-semibold text-brand-navy">{f.title}.</span> {f.body}
                  </span>
                </li>
              ))}
            </ul>
          </section>

          <div className="flex justify-center">
            <img
              src={images.appMockup}
              alt="The free Freeman Jones customer app"
              width="220"
              loading="lazy"
              className="rounded-[26px] border border-brand-border shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
